<template>
  <div>
    <button
      type="button"
      id="sidebarCollapse"
      class="btn bg-white border navbar-btn btn-social-md rounded-circle"
      :class="{ toggle: !showSideNav }"
      @click="toggleSideNav"
    >
      <i class="fa fa-angle-left outline-0 border-0"></i>
    </button>
    <nav class="sidebar" ref="sidebar" :class="{ active: !showSideNav }">
      <ul class="list-unstyled">
        <li>
          <a
            @click.prevent="
              submitAsteria('Menu', 'loadHTML_forMenu', {}, '', '/menu/')
            "
            href="#"
            ><i class="icn_home"></i><span class="nav-text">トップ</span>
          </a>
        </li>
        <li class="sub-menu sub_order" v-if="hasOrder">
          <a
            href="#order"
            data-toggle="collapse"
            :aria-expanded="checkExpanded('order') ? 'true' : 'false'"
            @click.prevent="toggleExpanded('order')"
            ><i class="icn_order"></i><span class="nav-text">ご発注</span></a
          >
          <div class="sub-content">
            <ul
              class="collapse list-unstyled"
              id="order"
              :class="{ show: checkExpanded('order') }"
            >
              <li v-if="loginUserInfo.auth_order_nomal">
                <a
                  @click.prevent="
                    submitAsteria(
                      'Order',
                      'loadHTML_forOrder',
                      {},
                      '/tab/order-simple',
                      '/order/#/tab/order-simple'
                    )
                  "
                  href="#"
                  >簡易発注</a
                >
              </li>
              <li v-if="loginUserInfo.auth_order_file">
                <a
                  @click.prevent="
                    submitAsteria(
                      'FileOrder',
                      'loadHTML_forFileOrder',
                      {},
                      '',
                      '/order/file.html'
                    )
                  "
                  href="#"
                  >ファイル発注</a
                >
              </li>
            </ul>
          </div>
        </li>
        <li class="sub-menu sub_refer" v-if="hasReference">
          <a
            href="/reference/"
            data-toggle="collapse"
            :aria-expanded="checkExpanded('reference') ? 'true' : 'false'"
            @click.prevent="toggleExpanded('reference')"
            ><i class="icn_refer"></i><span class="nav-text">ご参照 </span></a
          >
          <div class="sub-content">
            <ul
              class="collapse list-unstyled"
              id="refer"
              :class="{ show: checkExpanded('reference') }"
            >
              <li v-if="loginUserInfo.auth_ref_order">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferOrder',
                      'loadHTML_forReferOrder',
                      {},
                      '',
                      '/reference/order.html'
                    )
                  "
                  href="#"
                  >ご発注確認</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_orderrest">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferOrderRest',
                      'loadHTML_forReferOrderRest',
                      {},
                      '',
                      '/reference/order_rest.html'
                    )
                  "
                  href="#"
                  >ご発注残確認</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_purchaseresults">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferPurchaseResults',
                      'loadHTML_forReferPurchaseResults',
                      {},
                      '',
                      '/reference/purchase_results.html'
                    )
                  "
                  href="#"
                  >仕入実績</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_inventory">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferInventory',
                      'loadHTML_forReferInventory',
                      {},
                      '',
                      '/reference/inventory.html'
                    )
                  "
                  href="#"
                  >在庫照会</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_deliveryslip">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferDeliverySlip',
                      'loadHTML_forReferDeliverySlip',
                      {},
                      '',
                      '/reference/delivery_slip.html'
                    )
                  "
                  href="#"
                  >納品書</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_itemprice">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferItemPrice',
                      'loadHTML_forReferItemPrice',
                      {},
                      '',
                      '/reference/item_price.html'
                    )
                  "
                  href="#"
                  >価格照会</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_invoice">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferBill',
                      'loadHTML_forReferBill',
                      {},
                      '',
                      '/reference/bill.html'
                    )
                  "
                  href="#"
                  >請求書</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_printableitem">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferPrintableItem',
                      'loadHTML_forReferPrintableItem',
                      {},
                      '',
                      '/reference/printable_item.html'
                    )
                  "
                  href="#"
                  >印刷品確認</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_accounts_payable">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferPayable',
                      'loadHTML_forReferPayable',
                      {},
                      '',
                      '/reference/payable.html'
                    )
                  "
                  href="#"
                  >貴社請求書</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_csvhistory">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferCSVHistory',
                      'loadHTML_forCsvHistory',
                      {},
                      '',
                      '/reference/csv_history.html'
                    )
                  "
                  href="#"
                  >取込出力履歴</a
                >
              </li>
              <li v-if="loginUserInfo.auth_ref_productmaster">
                <a
                  @click.prevent="
                    submitAsteria(
                      'ReferProductMaster',
                      'loadHTML_forReferProductMaster',
                      {},
                      '',
                      '/reference/product_master.html'
                    )
                  "
                  href="#"
                  >商品マスタ照会</a
                >
              </li>
            </ul>
          </div>
        </li>
        <li
          v-if="
            loginUserInfo.auth_ref_npc &&
              loginUserInfo.npc_cd &&
              loginUserInfo.npc_cd != ''
          "
        >
          <a
            href="#"
            @click.prevent="
              submitAsteria(
                'NPCPurchaseResults',
                'loadHTML_forNPCPurchaseResults',
                {},
                '',
                '/reference/npc.html'
              )
            "
            ><i class="icn_npc"></i><span class="nav-text">NPC会員様用</span></a
          >
        </li>
        <li class="sub-menu sub_request" v-if="hasRequest">
          <a
            href="#request"
            data-toggle="collapse"
            :aria-expanded="checkExpanded('request') ? 'true' : 'false'"
            @click.prevent="toggleExpanded('request')"
            ><i class="icn_request"></i><span class="nav-text">ご依頼</span></a
          >
          <div class="sub-content">
            <ul
              class="collapse list-unstyled"
              id="request"
              :class="{ show: checkExpanded('request') }"
            >
              <li v-if="loginUserInfo.auth_req_estimate">
                <a
                  href="#"
                  @click.prevent="
                    submitAsteria(
                      'RequestEstimate',
                      'loadHTML_forRequestEstimate',
                      {},
                      '',
                      '/request/estimate.html'
                    )
                  "
                  >見積依頼</a
                >
              </li>
              <li v-if="loginUserInfo.auth_req_sample">
                <a
                  href="#"
                  @click.prevent="
                    submitAsteria(
                      'RequestSample',
                      'loadHTML_forRequestSample',
                      {},
                      '',
                      '/request/sample.html'
                    )
                  "
                  >サンプル依頼</a
                >
              </li>
              <li v-if="loginUserInfo.auth_req_catalogue">
                <a
                  href="#"
                  @click.prevent="
                    submitAsteria(
                      'RequestCatalog',
                      'loadHTML_forRequestCatalog',
                      {},
                      '',
                      '/request/catalogue.html'
                    )
                  "
                  >カタログ</a
                >
              </li>
              <li v-if="loginUserInfo.auth_req_envdocument">
                <a
                  href="#"
                  @click.prevent="
                    submitAsteria(
                      'RequestEnvironment',
                      'loadHTML_forRequestEnvironment',
                      {},
                      '',
                      '/request/environment.html'
                    )
                  "
                  >環境書類</a
                >
              </li>
              <li v-if="hasRequestState">
                <a href="#" @click.prevent="linkToRequestState">依頼状況</a>
              </li>
            </ul>
          </div>
        </li>
        <li v-if="loginUserInfo.auth_item_info">
          <a
            @click.prevent="
              submitAsteria(
                'ItemInfoDatasheetCatalogue',
                'loadHTML_forItemInfoDatasheetCatalogue',
                {},
                '',
                '/iteminfo/datasheetcatalogue.html'
              )
            "
            href="#product"
            ><i class="icn_product"></i
            ><span class="nav-text">商品情報</span></a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import { store as loginUserStore } from "../store/LoginUser";
import {
  store as BootstrapStore,
  mutations as BootstrapMutations,
  getters as BootstrapGetters
} from "../store/Bootstrap";

export default {
  props: {
    active: String
  },

  computed: {
    showSideNav() {
      return BootstrapStore.showSideNav;
    },
    loginUserInfo() {
      return loginUserStore.info;
    },
    hasOrder() {
      return (
        this.loginUserInfo.auth_order_nomal ||
        this.loginUserInfo.auth_order_file
      );
    },
    hasReference() {
      return (
        this.loginUserInfo.auth_ref_order ||
        this.loginUserInfo.auth_ref_orderrest ||
        this.loginUserInfo.auth_ref_purchaseresults ||
        this.loginUserInfo.auth_ref_inventory ||
        this.loginUserInfo.auth_ref_deliveryslip ||
        this.loginUserInfo.auth_ref_itemprice ||
        this.loginUserInfo.auth_ref_invoice ||
        this.loginUserInfo.auth_ref_printableitem ||
        this.loginUserInfo.auth_ref_csvhistory ||
        this.loginUserInfo.auth_ref_productmaster
      );
    },
    hasRequest() {
      return (
        this.loginUserInfo.auth_req_estimate ||
        this.loginUserInfo.auth_req_sample ||
        this.loginUserInfo.auth_req_catalogue ||
        this.loginUserInfo.auth_req_envdocument ||
        this.hasRequestState
      );
    },
    hasRequestState() {
      return (
        this.loginUserInfo.auth_ref_estimate ||
        this.loginUserInfo.auth_ref_samplecatalogue ||
        this.loginUserInfo.auth_ref_envdocument
      );
    }
  },

  mounted() {
    this.$nextTick(() => {
      // if (this.active) {
      //   this.toggleExpanded(this.active);
      // }

      if (this.$refs.sidebar) {
        new PerfectScrollbar(this.$refs.sidebar);
      }

      BootstrapStore.hasSideNav = true;
    });
  },

  methods: {
    checkExpanded: function(key) {
      return BootstrapGetters.checkExpandedSideNav(key);
    },
    toggleExpanded: function(key) {
      BootstrapMutations.toggleExpandedSideNav(key);
    },
    toggleSideNav: function() {
      BootstrapMutations.toggleSideNav();
    },

    linkToRequestState() {
      // 見積依頼状況
      if (this.loginUserInfo.auth_ref_estimate) {
        return this.submitAsteria(
          "RequestStateEstimate",
          "loadHTML_forRequestStateEstimate",
          {},
          "",
          "/requeststate/estimate.html"
        );
      }

      // サンプルカタログ依頼状況
      if (this.loginUserInfo.auth_ref_samplecatalogue) {
        return this.submitAsteria(
          "RequestStateSampleCatalogue",
          "loadHTML_forRequestStateSampleCatalogue",
          {},
          "",
          "/requeststate/samplecatalogue.html"
        );
      }

      // 環境依頼状況
      if (this.loginUserInfo.auth_ref_envdocument) {
        return this.submitAsteria(
          "RequestStateEnvironment",
          "loadHTML_forRequestStateEnvironment",
          {},
          "",
          "/requeststate/environment.html"
        );
      }
    }
  }
};
</script>
